"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketWebsiteOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketWebsiteOutput.js.map